import {
  ButtonFill,
  ButtonGhost,
  PageTemplate,
  StyledButtonContent,
} from '@npco/zeller-design-system'
import styled, { css } from 'styled-components'

export const HeaderSecondaryRowWrapper = styled(
  PageTemplate.HeaderSecondaryRow
)<{
  $isActive: boolean
}>`
  flex-direction: column;
  max-height: 0;
  transform-origin: top;
  transform: scaleY(0);
  transition: all 0.3s ease-out;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.XS}) {
    padding-top: ${({ $isActive }) => ($isActive ? '24px' : '0px')};
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      max-height: 100px;
      opacity: 1;
      transform: scaleY(1);
    `}
`

export const InvoiceButton = styled(ButtonFill)`
  ${StyledButtonContent} {
    gap: 10px;
  }

  padding: 12px 16px;
  max-height: 48px;
`

export const InvoiceIconButton = styled(ButtonFill)`
  line-height: 0;
  padding: 16px;
  max-height: 48px;
`

export const SettingsButton = styled(ButtonGhost)`
  padding: 12px 24px;
`

export const ActiveFilterIndicator = styled.div`
  background: ${({ theme }) => theme.colors.RED_1000};
  border: 2px solid ${({ theme }) => theme.colors.WHITE};
  border-radius: 50%;
  height: 10px;
  position: absolute;
  width: 10px;
  z-index: 10;
  right: 10px;
  top: 6px;
`

export const SearchWrapper = styled.div`
  position: relative;
`
